import classNames from 'classnames/bind';

import styles from './Target.module.scss';
import { TargetIcon, TargetLongIcon } from '../Icons/Icons';

const cx = classNames.bind(styles);

function Target() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner')}>
                <div className={cx('header')}>
                    <h1>MỤC TIÊU</h1>
                </div>
                <div className={cx('content', 'grid')}>
                    <div className={cx('short', 'row')}>
                        <div className={cx('title', 'col', 'p-3')}>
                            <h2 className={cx('h2')}>Mục tiêu ngắn hạn</h2>
                            <div className={cx('icon', 'short-target-icon')}>
                                <TargetIcon />
                            </div>
                        </div>
                        <div className={cx('des', 'col', 'p-9')}>
                            <p>
                                Đến lúc này mình đã học lập trình - cụ thể là Font-end được khoảng 7
                                tháng, và cũng đã học được rất nhiều kiến thức, áp dụng nó vào trong
                                dự án cá nhân. Mục tiêu ngắn hạn trong vòng 03 tháng tiếp tục học
                                sâu về ReactJS, về JavaScript, và cả về thiết kế UI/UX. Đồng thời
                                cải thiện trình độ Tiếng Anh (đặc biệt là đọc và nói) nhằm cải thiện
                                trình độ tối thiểu đọc document cho việc học. Mục tiêu cao hơn là có
                                thể đọc hiểu các tài liệu chuyên ngành bằng Tiếng Anh.
                            </p>
                            <br></br>
                            <p>
                                Mục tiêu tiếp đến của lộ trình ngắn hạn là xin vào làm việc thực tập
                                tại một công ty nào đó, để có cơ hội va chạm với các dự án thực tế
                                cũng như phong cách, tiến độ làm việc thực tế.
                            </p>
                        </div>
                    </div>
                    <div className={cx('long')}>
                        <div className={cx('fullwidth', 'row')}>
                            <div className={cx('des', 'col', 'p-9')}>
                                <p>
                                    Mục tiêu dài hạn mình đặt ra là trong vòng tối đa một năm tới
                                    phải hoàn thành chương trình học tại trường Đại học, kể cả khóa
                                    luận tốt nghiệp. Trở thành nhân viên chính thức của công ty và
                                    tham gia hoàn thiện vào ít nhất một dự án thực tế.
                                </p>
                                <br></br>
                                <p>
                                    Đối với mục tiêu dài hơn nữa là 3 năm tới trở thành lập trình
                                    viên có kiến thức chuyên môn vững vàng trong mảng Font-end. Nhìn
                                    nhận rõ ràng và mạch lạc các yếu tố UI/UX. Và mục tiêu dài hạn
                                    hơn nữa là làm ra sản phẩm phục vụ cho chính công việc của bản
                                    thân, dự án cá nhân phục vụ cộng đồng mà mình đang ấp ủ!
                                </p>
                            </div>
                            <div className={cx('title', 'col', 'p-3')}>
                                <h2 className={cx('h2')}>Mục tiêu dài hạn</h2>
                                <div className={cx('icon', 'long-target-icon')}>
                                    <TargetLongIcon />
                                </div>
                            </div>
                        </div>
                        <div className={cx('max1024px', 'row')}>
                            <div className={cx('title', 'col', 'p-3')}>
                                <h2 className={cx('h2')}>Mục tiêu dài hạn</h2>
                                <div className={cx('icon', 'long-target-icon')}>
                                    <TargetLongIcon />
                                </div>
                            </div>
                            <div className={cx('des', 'col', 'p-9')}>
                                <p>
                                    Mục tiêu dài hạn mình đặt ra là trong vòng tối đa một năm tới
                                    phải hoàn thành chương trình học tại trường Đại học, kể cả khóa
                                    luận tốt nghiệp. Trở thành nhân viên chính thức của công ty và
                                    tham gia hoàn thiện vào ít nhất một dự án thực tế.
                                </p>
                                <br></br>
                                <p>
                                    Đối với mục tiêu dài hơn nữa là 3 năm tới trở thành lập trình
                                    viên có kiến thức chuyên môn vững vàng trong mảng Font-end. Nhìn
                                    nhận rõ ràng và mạch lạc các yếu tố UI/UX. Và mục tiêu dài hạn
                                    hơn nữa là làm ra sản phẩm phục vụ cho chính công việc của bản
                                    thân, dự án cá nhân phục vụ cộng đồng mà mình đang ấp ủ!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Target;
